import { computed, signal } from '@angular/core';

export class OrderSubmissionGuard {
  private readonly loading$$ = signal(false);
  private readonly submitted$$ = signal(false);

  readonly isLoading$$ = this.loading$$.asReadonly();
  readonly isSubmitted$$ = this.submitted$$.asReadonly();
  readonly canSubmit$$ = computed(() => !this.loading$$() && !this.submitted$$());

  canSubmit(): boolean {
    return this.canSubmit$$();
  }

  tryStart(): boolean {
    if (!this.canSubmit()) {
      return false;
    }

    this.loading$$.set(true);

    return true;
  }

  markSuccess(): void {
    this.submitted$$.set(true);
    this.loading$$.set(false);
  }

  markError(): void {
    this.loading$$.set(false);
  }
}
